import { render, staticRenderFns } from "./DocTemplateFormV2.vue?vue&type=template&id=6dc2e9b8&"
import script from "./DocTemplateFormV2.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateFormV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports